import styled from '@emotion/styled'
import {
  btnFocus,
  underlineFocus,
} from 'portal-modules/common/components/focus-styles'
import CustomContent from 'portal-modules/common/components/CustomContent'
import Button from 'portal-modules/common/components/Button'
import { css } from '@emotion/core'
import colorCode from 'portal-modules/common/constants/color-codes'
import TabNav from 'portal-modules/common/components/tab-nav'
import { PortalModal } from 'portal-modules/common/components/modals/portal-modal'
import { RoundedCheckBox } from 'portal-modules/common/components/checkbox'
import CardIcon from 'portal-modules/common/components/CardIcon'
import {
  CircleCheck,
  CircleAdd,
  Download,
  AlertTriangle,
  Lock,
  Fingerprint,
  Info
} from '@entrata/portals-common/lib/icons'
import { Form } from '@entrata/portals-common/lib/components'
import { StyledCard } from 'portal-modules/payments/components/refund-account/atom'
import {
  TextAreaField,
  CurrencyField,
  PickerField,
} from '@entrata/portals-common/lib/boxed-fields'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import getDynamicTextColor from 'portal-modules/common/utils/get-dynamic-text-color'
import { Link } from 'react-router-dom'

export const StyledPaymentHeaderArticle = styled('article')`
  display: flex;
  align-items: ${({ showBalance }) =>
    showBalance? 'flex-start' : 'flex-end'};
  gap: 24px;
  align-self: stretch;
  flex-direction: column;
  background: ${({ theme }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : theme.paymentHeader.background};
  box-sizing: border-box;
  border: 0.33px solid ${({ theme }) => theme.paymentHeader.border};
  border-radius: 24px;
  padding: 24px 41px;
  margin-top: 24px;
  margin-bottom:${ getEmbeddedViewFlag() ? '24px' : 'initial'};
  
  @media only screen and (max-width: 480px) {
    flex-direction: column;
    text-align: center;
    padding: 24px 24px 32px 24px;
  }
`
export const StyledPaymentBalanceHeader = styled('header')`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.white.base};
  flex: 1 0 auto;
  text-align: ${({ showBalance, allowPayment }) =>
    showBalance || allowPayment ? `left` : 'center'};

  @media only screen and (max-width: 480px) {
    text-align: center;
  }
`

export const StyledAutoPaymentStatusDivider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.paymentHeader.border};
`;

export const StyledPaymentHeaderTopTitle = styled('div') `
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const StyledPaymentHeaderTopAmount = styled('div')`
  display: flex;
  margin: 0;
  gap: 8px;
`
export const StyledPaymentIcon = styled('span')`
  display: flex;

  svg {
    height: 24px;
    width: 24px;
    cursor: pointer;
    pointer-events: auto !important;
    @media only screen and (min-width: 1024px) {
      text-transform: capitalize;
    }

    @media only screen and (max-width: 480px) {
      height: 20px;
      width: 20px;
    }

    path {
      fill: ${({ theme }) => theme.gray.mediumlight};
    }
  }
`

export const StyledSvg = styled('span')`
  fill: ${({ theme }) => theme.mode.text_color};
  border-radius: 8px;
  border: 1px solid var(--Surface-surface-border-2, #E5E5E6);
  background: var(--Surface-background-2, #FCFCFD);
  padding: 1px 9px;
  display: flex;
  width: 48px;
  height: 32px;
  padding: 1px 9px;
  justify-content: center;
  align-items: center;
`

export const StyledSvgSpan = styled('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  font-style: italic;
`

export const StyledViewDetailsWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`

export const StyledPaymentHeaderH2 = styled('h2')`
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.25px;
  text-align: left;
  margin: 0;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.mediumlight};

  @media only screen and (min-width: 1024px) {
    text-transform: capitalize;
  }

  @media only screen and (max-width: 480px) {
    font-size: 15px;
    text-align: left;
  }
  span {
    display: contents;
  }
`

export const StyledPaymentBalanceP = styled('p')`
  font-size: 24px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0.5px;
  text-align: left;
  margin: 0;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.mediumlight};
  @media only screen and (max-width: 480px) {
    font-size: 24px;
    text-align: left;
  }
  span {
    font-size: x-large;
    vertical-align: super;
  }
`

export const StyledPaymentHeaderAside = styled('aside')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a:hover {
    white-space: nowrap !important;
  }
  
  @media only screen and (min-width: 768px) {
    flex-direction: row;
  }
  @media only screen and (min-width: 1619px) {
    padding: 0 6px;
  }

  @media only screen and (max-width: 480px) {
    ${'' /* margin: 24px 0 0 0; */}
  }
  span {
    display: contents;
  }
`

export const StyledPaymentHeaderIcon = styled('div')`
  width: 5%;
  margin-left: 138px;
  margin-top: -24px;
  @media only screen and (max-width: 767px) {
    padding-left: 0;
  }
`

export const StyledPaymentHeaderText = styled('h5')`
  font-size: 16px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.embedded.button_text : getDynamicTextColor(theme.primary.base)};
`

export const StyledPaymentTabNavItem = styled(TabNav.Item)`
  font-size: 13px;
  letter-spacing: 0.8px;

  .tabs--header & {
    color: ${({ theme }) =>
      getEmbeddedViewFlag() ? theme.secondary.base : theme.gray.gray4};
  }

  &.active {
    color: ${({ theme }) =>
      getEmbeddedViewFlag() ? theme.secondary.base : theme.gray.gray4};
  }
`

export const StyledPaymentButton = styled(Button)`
  background-color: ${({ theme }) =>
    getEmbeddedViewFlag()
      ? theme.button_primary.background
      : theme.primary.base};
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.embedded.button_text : theme.text.white};
  text-transform: none;
  height: 48px;
  width: 119px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
`

export const paymentBtnStyle = css`
  background-color: ${({ theme }) =>
    getEmbeddedViewFlag()
      ? theme.button_primary.background
      : '${colorCode.WHITE}'}; /*Do not change the color definations*/
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.embedded.button_text : '${colorCode.WHITE}'};
  background-color: ${({ theme }) =>
    theme.primary.base ||
    colorCode.PURPLE}; /*Do not change the color definations*/
  border: ${getEmbeddedViewFlag()} ? none; : 1px solid ${colorCode.WHITE};
  width: 119px;
  font-weight: 700;
  :nth-child(2) {
    margin-top: 4px;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 1 auto;
    :nth-child(2) {
      margin-top: auto;
    }
  }

  @media only screen and (max-width: 768px){
    width:100%;
    padding: 0 10px;
    height: 48px;
  }

  @media only screen and (max-width: 500px) {
    height: 48px;
    margin-bottom: ${getEmbeddedViewFlag() && '15px'};
  }

  @media only screen and (max-width: 425px) {
    width: 100%;
  }
`

export const StyledOneTapPayLock = styled(Lock)`
  position: relative;
  top: 4px;
  color: #58595b;
  margin-right: 10px;
`

export const StyledPaymentMethodButton = styled(Button)`
  display: inline-block;
  position: ${isfromRPOneTapPay =>
    isfromRPOneTapPay ? 'relative' : 'absolute'};

  @media only screen and (max-width: 768px) {
    left: 0;
  }
  ${isfromRPOneTapPay =>
    !isfromRPOneTapPay
      ? `padding: 24px 62px;
  width: 300px;
  height: 64px;`
      : `margin: 16px;`}
`

export const StyledOneTapPayButtonWrapperContent = styled('div')`
  display: flex;
  margin-bottom: 24px;
`

export const StyledH1 = styled('h1')`
  font-size: 20px;
  font-weight: bold;
  margin: ${fromoneclick => (fromoneclick ? '10px 20px' : '0')};
`

export const StyledAutoPaymentHeader = styled('header')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.gray5};
  background-color: ${({ theme }) =>
    theme.mode.isDark ? theme.mode.background_color : ''};
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: ${({ noUpper }) => !noUpper && 'uppercase'};
  padding: 16px 32px;
  border: ${({ theme }) => `1px solid ${theme.gray.gray3}`};
  border-radius: 24px;
  height: 172px;

  @media only screen and (max-width: 480px) {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border: none;
  }
`

export const StyledHeader = styled('header')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.gray5};
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: ${({ noUpper }) => !noUpper && 'uppercase'};
  padding: 16px 32px;
  border: ${({ theme }) => `1px solid ${theme.gray.gray3}`};
  border-radius: 24px;
  height: 172px;

  @media only screen and (max-width: 480px) {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border: none;
  }
`

export const StyledMoneyGramContent = styled('div')`
  @media only screen and (max-width: 767px) {
    padding: 5% 8%;
  }
`

export const StyleNoUpperdH2 = styled('h2')`
  font-size: 21px;
  font-weight: 700;
  margin: 0 8px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.gray5};

  @media only screen and (max-width: 414px) {
    margin-bottom: 16px;
  }
`

export const StyledH2 = styled('h2')`
  font-size: 18px;
  font-weight: ${p => p.fontWeight || 'bold'};
  text-transform: ${({ p, fromoneclick }) =>
    fromoneclick ? 'none' : p?.textTransform || 'uppercase'};
  margin: ${fromoneclick => (fromoneclick ? '10px 20px' : '0')};
`

export const StyledBalanceP = styled('p')`
  font-weight: ${p => (p.isBold ? 'bold' : '200')};
  margin: 0;
  line-height: 1.2;
  text-align: right;
`

export const StyledBoldBalanceP = styled('p')`
  font-size: 18px;
  margin: 0;
  text-align: right;
`

export const StyledInvoiceNextButton = styled(Button)`
  margin-top: 10px;
  font-size: 14px;
  text-align: center;

  @media only screen and (max-width: 767px) {
    margin-top: 30px;
  }

  :disabled {
    cursor: not-allowed;
  }
`

export const StyledInvoiceContent = styled('div')`
  @media only screen and (max-width: 767px) {
    padding: 20px 20px;
  }
`

export const StyledInvoiceTextArea = styled(TextAreaField)`
  font-size: 14px;
  min-height: 160px;
`

export const StyledInvoiceTextMsg = styled('div')`
  color: ${({ theme }) => theme.text.dark};
  font-size: 12px;
  margin: 10px 0;
`

export const StyledFeeSpan = styled('span')`
  font-size: 13px;
  font-weight: 400;
  text-transform: capitalize;
  display: block;
  text-align: ${getEmbeddedViewFlag() ? 'center' : 'right'};
  margin-left: 15px;
  ${({ theme }) => theme.gray.gray4};

  @media only screen and (max-width: 414px) {
    font-size: 13px;
  }
`

export const StyledSpanWrapper = styled('span')`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 414px) {
    align-items: center;
  }
`

export const StyledAmountSection = styled('div')`
  font-size: 48px;
  font-weight: 400;
  text-transform: capitalize;
  display: block;
  text-align:${getEmbeddedViewFlag() ? 'center' : 'right' };
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.white : theme.gray.gray4};
  margin-bottom: 16px;

  @media only screen and (max-width: 414px) {
    font-size: 36px;
    margin-bottom: 8px;
  }
`

export const StyledDivWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 767px) {
    border: none;
    padding: 0 16px;
  }
`

export const StyledFlexLink = styled('a')`
  text-decoration: none;
  &:hover {
    text-decoration: none; 
  }
`

export const StyledUl = styled('ul')`
  margin: 0;
  padding: 0;
  border-bottom: ${({ bottomBorder }) =>
    bottomBorder ? '2px solid rgba(255,255,255,0.2)' : 'none'};
  margin-top: ${({ noMarginTop }) => noMarginTop && '0'};

  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
`

export const StyledLi = styled('li')`
  list-style: none;
  display: inline-block;
  padding: 16px 24px;
  border-right: ${({ active }) =>
    active ? 'none' : '2px solid rgba(255,255,255,0.2)'};

  &:last-child {
    border-right: none;
  }

  @media only screen and (min-width: 768px) {
    ${({ active }) => active && 'background-color:rgba(255,255,255,0.2);'}
  }

  @media only screen and (max-width: 767px) {
    background-color: none;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;

    p {
      ${({ active }) => active && 'font-weight: 600;'}
    }

    &:last-child {
      border-top: 2px solid rgba(255, 255, 255, 0.2);

      p {
        font-weight: 600;
      }
    }
  }
`

export const StyledSpan = styled('span')`
  color: white;
  display: block;
  font-size: 12px;
  font-style: italic;

  @media only screen and (max-width: 767px) {
    font-style: normal;
    font-size: 13px;
  }
`

export const StyledAmountP = styled('p')`
  color: white;
  font-size: 18px;
  font-weight: 500;
  margin: 0;
`

export const StyledDivWrapperInfo = styled('div')`
  color: white;
  display: flex;
  padding-bottom: 0;

  @media only screen and (max-width: 767px) {
    padding: 0 16px;
  }
`

export const StyledSpanLabel = styled('span')`
  color: white;
  display: block;
  font-size: 12px;
  font-style: italic;

  @media only screen and (max-width: 959px) {
    color: white;
  }
`

export const StyledTextP = styled('p')`
  color: white;
  font-size: 14px;
  font-weight: 500;
  margin: 0;

  @media only screen and (max-width: 959px) {
    color: white;
  }
`

export const StyledLiInfo = styled('li')`
  list-style: none;
  display: inline-block;
  padding: 16px 56px 16px 16px;
`

export const StyledPaymentInfoP = styled('p')`
  color: white;
  font-size: 13px;
`

export const StyledPNote = styled('p')`
  color: ${({ theme }) => theme.text.dark};
  font-size: 13px;
  font-style: italic;
  margin-top: 0;
`

export const StyledLabel = styled('h5')`
  texttransform: uppercase;
  marginbottom: 0;
`

export const StyledText = styled('p')`
  font-size: 11px;
  margin:0px;
  margin-left: 44px;
  margin-bottom: 8px;
`
export const StyledErrorTextP = styled(StyledText)`
  color: red;
`

export const StyledPageContent = styled('section')`
  position: relative;
  height: ${({ noHeight }) => (noHeight ? `` : `100%`)};
  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @media only screen and (min-width: 960px) {
    display: flex;
    flex-direction: row;
  }
`

export const StyledWrapperDiv = styled('div')`
  @media only screen and (min-width: 768px) {
    width: 50%;
    :last-of-type {
      margin-left: 32px;
    }
  }
`

export const StyledInfoDl = styled('dl')`
  border-bottom: 2px solid ${({ theme }) => theme.gray.light};
  line-height: 32px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  white-space: pre-wrap;
`

export const StyledInfoDt = styled('dt')`
  width: ${({ dynamicWidth }) => (dynamicWidth ? dynamicWidth : '60%')};
  display: inline-block;
  margin: 4px 0;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};
  font-size: 15px;
`

export const StyledInfoDd = styled('dd')`
  width: ${({ dynamicWidth }) => (dynamicWidth ? dynamicWidth : '40%')};
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};

  display: inline-block;
  text-align: right;
  margin: 4px 0;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};
  font-size: 15px;

  a {
    color: ${({ theme }) => theme.secondary.base};
    text-decoration: none;
    ${underlineFocus};
  }
`

export const StyledPausedPaymentMessage = styled('dd')`
  display: inline-block;
  margin: 4px 0;
  color: ${({ theme }) => theme.gray.dark};
  font-size: 15px;

  a {
    color: ${({ theme }) => theme.secondary.base};
    text-decoration: none;
    ${underlineFocus}
  }
`

export const StyledIconButton = styled('button')`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.secondary.base};
  height: 24px;
  padding: 0;
  width: 24px;

  ${underlineFocus};

  &:not(:last-child) {
    margin-right: 8px;
    margin-left: 8px;
  }
`

export const StyledMoneyGramAnchor = StyledIconButton.withComponent('a')

export const StyledMoneyGramSection = styled('section')`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  @media (min-width: 960px) {
    position: relative;
  }
`

export const StyledMoneyGramSpan = styled('span')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
`

export const StyledMoneyGramLabel = styled('h3')`
  font-size: 13px;
  font-weight: bold;
  line-height: 1.5;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`
export const StyledMoneyGramInformationLabel = styled('h3')`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.5;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`

export const StyledMoneyGramButton = styled(Button)`
  margin-bottom: 8px;

`

export const StyledSpanishInstructionButton = styled(Button)`
  padding: 8px 24px;
`
export const StyledMoneyGramFigure = styled('figure')`
  position: absolute;
  top: 50px;
  right: -200px;
`

export const StyledConfirmHeader = styled('h3')`
  border-bottom: 2px solid ${({ theme }) => theme.gray.highlight};
  font-size: 18px;
  padding-bottom: 16px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};
  font-weight: bold;
`

export const StyledPausedHeader = styled('h3')`
  font-size: 18px;
  color: ${({ theme }) => theme.gray.dark};
  font-weight: bold;
`

export const StyledConfirmFooter = styled('section')`
  @media only screen and (max-width: 767px) {
    margin: 0px auto;
    text-align: center;
    display: flex;
  }
`
export const StyledCustomContent = styled(CustomContent)`
  @media screen and (min-width: 768px) {
    margin: 0;
    padding: ${({ isLedger }) =>
      isLedger ? `16px 16px 16px 24px` : `24px 16px 16px 32px`};
  }

  @media screen and (min-width: 960px) {
    padding: ${({ isLedger, isRepayment }) =>
      isLedger || isRepayment ? `16px 16px 16px 0` : `24px 16px 16px 32px`};
    margin-bottom: ${({ isRepayment }) => (isRepayment ? '0px' : '24px')};
  }
`

export const StyledP = styled('p')`
  font-size: 12px;
  font-style: italic;
  margin-bottom: 16px;
`

export const StyledH5 = styled('h5')`
  margin: 0;
  text-transform: none;
`

export const StyledWrapperUL = styled('ul')`
  color: ${({ theme }) => theme.text.dark};
  list-style-type: none;
  margin: 0;
  padding: 0;
`
export const StyledA = styled('a')`
  ${btnFocus}
`
export const StyledListItem = styled('li')`
  margin-bottom: 12px;
`
export const StyledNavItemDetails = styled('section')`
  display: flex;
  justify-content: flex-start;
  font-weight: bold;
  margin-bottom: 24px;
  margin-top: 10px;
`
export const StyledBoldNavItem = styled('span')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.text.dark};
  font-size: 16px;
  padding-left: 10px;
  letter-spacing: 0.29px;
  line-height: 19px;
  font-weight: bold;
  margin-left: 5px;
`
export const StyledHr = styled('hr')`
  background-color: ${({ theme }) => theme.gray.light};
  height: ${({ height }) => height};
  margin-top: ${({ marginTop }) => marginTop};
  border: 0;
  width: 100%;
`
export const StyledDivRight = styled('div')`
  padding: 4px 0;
  background: 'transparent';
  float: right;
  height: 18px;
  font-weight: ${({ fontWeight }) => fontWeight};
  font-style: ${({ fontStyle }) => fontStyle};
  font-size: ${({ fontWeight }) => (fontWeight ? '21px' : '15px')};
`
export const StyledDivLeft = styled('div')`
  padding: 4px 0;
  background: 'transparent';
  float: left;
  clear: both;
  height: ${({ isPaymentMemo }) => (isPaymentMemo ? 'auto' : '18px')};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-style: ${({ fontStyle }) => fontStyle};
  font-size: 15px;
`
export const StyledDivWithoutDots = styled('div')`
  margin-top: 2px;
  height: 16px;
`
export const StyledDivDots = styled(StyledDivWithoutDots)`
  border-bottom: 2px dotted ${({ theme }) => theme.gray.light};
`
export const StyledDiv = styled('div')`
  float: left;
  width: ${({ fromOneclick, fromOneclickMobile }) =>
    fromOneclick ? '60%' : fromOneclickMobile ? '90%' : '100%'};
  font-family: 'Inter';
  margin-right: 8px;
  margin-bottom: 8px;
  margin-left: ${({ fromOneclick, fromOneclickMobile }) =>
    fromOneclick || fromOneclickMobile ? '20px' : '0'};
  font-size: 15px;
  @media only screen and(max-width: 767px) {
    width: 100 %;
    margin-left: 0;
    font-size: 13px;
  }
`

export const StyledPaddingDiv = styled('div')`
  padding: 24px 32px;
  width: 100%;
  height: 86%;
  overflow: scroll;

  @media screen and (min-width: 768px) {
    top: 0;
    position: absolute;
  }
`

export const StyledConfirmHeaderNote = styled('div')`
  background-color: ${({ theme }) => theme.backgroundColor.redish_light};
  height: 90px;
  padding: 20px 32px 24px 33px;
  display: flex;
  margin: -30px -32px 0px -32px;

  border-radius: 8px 8px 0 0;

  @media only screen and (min-width: 768px) {
    height: 79px;
  }
`

export const StyledPaddingDivNoScroll = styled('div')`
  padding: 24px 32px;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    top: 0;
    position: absolute;
  }
`

export const LineSeparatorDiv = styled('div')`
  border-bottom: 2px solid ${({ theme }) => theme.fields.border};
  margin-top: ${({ noMargin }) => (noMargin ? `0` : `50px`)};
`

export const StyledConfirmtionHeader = styled('h3')`
  font-size: 18px;
  color: ${({ theme }) => theme.gray.dark};
  font-weight: bold;
`
export const StyledPadding = styled('div')`
  @media only screen and (max-width: 767px) {
    padding: 0 32px 0;
  }
`
export const StyledCardIcon = styled('span')`
  border: 1px solid ${p => p.theme.gray.light};
  padding: 2px 2px 0px 2px;
  border-radius: 4px;
  float: left;
  height: 21px;
`

export const StyledButton = styled(Button)`
  margin-right: 10px;
`

export const StyledAutopaymentButton = styled(Button)`
  margin-bottom: 16px;

  @media only screen and (min-width: 834px) and (max-width: 965px) {
    width: auto;
    margin-right: 0;
  }
`

export const StyledEditButton = styled(Button)`
  margin-top: ${fromOneclickMobile => (fromOneclickMobile ? '20px' : '0')};
  margin-left: ${fromOneclickMobile => (fromOneclickMobile ? '0' : '25%')};
`

export const StyledDisclaimer = styled('p')`
  font-size: ${({ smallScreen, isPropsedSplit }) =>
    smallScreen && isPropsedSplit ? '13px' : '11px'};
  font-style: italic;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.gray.dark};
  margin: ${({ isPropsedSplit, isEvenNumber }) =>
    isPropsedSplit
      ? '0 0 28px 0'
      : isEvenNumber
        ? '-8px 0 20px 0'
        : '10px 5px 20px 0'};
`

export const StyledWarningDiv = styled('div')`
  background-color: ${({ theme }) =>
    theme.mode.isDark ? 'transparent' 
    : getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : theme.gray.highlight};
  height: 120px;
  padding: 16px 32px 24px 33px;
  display: flex;
  margin: -8px -32px 24px -32px;

  @media only screen and (min-width: 768px) {
    margin: 0 -32px 16px;
    height: 79px;
  }
`

export const StyledOneTapPayContent = styled('div')`
  font-size: 11px;
  font-style: italic;
  margin-bottom: 16px;
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.text.medium};

  @media only screen and (min-width: 768px) {
    font-size: 12px;
  }
`

export const StyledAlertTriangle = styled(AlertTriangle)`
  margin-top: 12px;
  color: red;
`

export const StyledWarningP = styled('p')`
  font-size: 12px;
  font-style: italic;
  display: inline-block;
  margin-left: 16px;
  margin-bottom: 10px;
`

export const StyledDownload = styled('a')`
  float: right;
  color: rgb(52, 81, 139);
  font-weight: normal;
  text-decoration: none;
`

export const StyledOneClickAutoPaymentModal = styled(PortalModal)`
  max-width: 500px;
`

export const StyledOneClickAutoPaymentSpan = styled('span')`
  margin: 5px;
`

export const StyledOneClickAutoPaymentButton = styled(Button)`
  margin-bottom: 16px;
`

export const StyledOneClickAutoPaymentTitle = styled('span')`
  color: ${({ theme }) => `${theme.gray.dark}`};
  font-size: 16px;
`

export const StyledOneClickAutoPaymentDivRight = styled(StyledDivRight)`
  width: 48%;
  height: auto;
  display: flex;
  font-size: 15px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;

  ${'' /* > span.one-click-auto-payment-content {
    text-align: right;
    width: 100%;
    position: relative;
  } */}
`
export const StyledOneClickAutoPaymentDivLeft = styled(StyledDivLeft)`
  width: 48%;
  height: auto;
`
export const StyledOneClickAutoPaymentDiv = styled(StyledDiv)`
  width: 90%;
  min-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
`
export const StyledOneClickAutoPaymentButtonContainer = styled(StyledDiv) `
  width: 90%;
  min-height: 30px;
`
export const StyledOneClickAutoPaymentCardIcon = styled(StyledCardIcon)`
  height: auto;
`

export const StyledOneClickAutoPaymentH1 = styled(StyledH1)`
  height: 24px;
  font-size: 21px;
  line-height: 24px;
  margin-top: 16px;

  @media only screen and (max-width: 480px) {
    margin-top: 8px;
  }
`
export const StyledOneClickAutoPaymentH2 = styled(StyledH2)`
  height: 22px;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.5px;
  text-transform: capitalize;
`

export const StyledLoaderContainer = styled('div')`
  padding: 30%;
  text-align: center;
`

export const StyledOneClickAutoPaymentValue = styled('span') ``
//-- One Tap Pay

export const OneTapPayHeaderText = styled('h5')`
  left: 274px;
  font-weight: 700;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 24px 16px 24px 0;
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.primary.base};

  @media only screen and (max-width: 767px) {
    margin-left: 16px;
    font-size: 20px;
  }
`

export const StyledLoaderDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const OneTapPayBubble = styled('div')`
  box-sizing: border-box;
  width: auto;
  font-size: 13px;
  padding-bottom: ${({ extended }) => (extended ? '70px' : '16px')};
  margin-top: 16px;
  border-radius: 24px;
  background: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.white.base};
  border: ${({ error, theme }) =>
    getEmbeddedViewFlag()
      ? `1px solid ${theme.embedded.input_border_outline}`
      : error
        ? `1px solid ${theme.error.base}`
        : `1px solid ${theme.gray.light}`};

  @media only screen and (max-width: 767px) {
    margin-right: 16px;
    margin-left: 16px;
  }
`
export const StyledOneTapPayDownloadButton = styled('a')`
  margin-top: 32px;
  border: 1px solid ${({ theme }) => `${theme.gray.light}`};
  border-radius: 20px;
  padding: 8px;
  margin-right: 16px;
  text-decoration: none;
  color: ${({ theme }) => `${theme.gray.gray5}`};
  height: 32px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.mode.isDark ? 'transparent' : theme.backgroundColor.white};
  stroke: ${({ theme }) => theme.gray.light};

  span:nth-child(1) {
    display: flex;
  }

  @media only screen and (max-width: 768px) {
    margin-top: 16px;
    padding: 8px;
  }
`

export const StyledOneTapPayWrapperDiv = styled('div')`
  @media only screen and (min-width: 768px) {
    width: 95%;
    :last-of-type {
      margin-left: 32px;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 10px;
    top: 0%;
    position: absolute;
  }
`

export const StyledOneTapPayConfirmHeader = styled('h1')`
  font-size: 20px;
  padding-bottom: 10px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark}; 
  font-weight: bold;
  margin: 24px 0 8px 0;

  @media only screen and (max-width: 414px) {
    font-size: 18px;
  }
`

export const StyledAutoPaymentConfirmHeader = styled('h1')`
  font-size: 20px;
  color: ${({ theme }) => theme.gray.dark};
  font-weight: bold;
  margin: 16px 0 8px 0;
`

export const StyledOneTapBoldText = styled('div')`
  font-weight: bold;
  display: block;
`

export const StyledOneTapPaySubHeader = styled('p')`
  font-size: 14px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};
  margin-top: 0;
`
export const StyledAutoPaymentSubHeader = styled('p')`
  font-size: 14px;
  color: ${({ theme }) => theme.gray.dark};
  margin-top: 0;
`

export const StyledOneTapPayCancelButton = styled('a')`
  margin-top: 38px;
  text-decoration: none;
  color: ${({ theme }) => `${theme.blue.base}`};
  display: ${({ show }) => show ? 'none' : 'inline'};
  @media only screen and (max-width: 768px) {
    margin-top: 23px;
  }
`

export const StyledOneTapPayCloseButton = styled('span')`
  color: ${({ theme }) => theme.text.dark};
  cursor: pointer;
  float: right;
  margin-right: 16px;
  display: ${({ show }) => show ? 'none' : 'inline'};

  @media only screen and (max-width: 768px) {
    margin: 0;
  }
`

export const OneTapPaySuccessBubble = styled('div')`
  display: grid;
  text-align: center;
  box-sizing: border-box;
  width: 50%;
  font-size: 12px;
  margin-left: 20%;
  padding: 10px;
  @media only screen and (max-width: 767px) {
    width: auto;
    margin: auto;
  }
  left: 274px;
  top: 144px;

  margin-bottom: 16px;
  padding-bottom: ${({ extended }) => (extended ? '70px' : '16px')};
  margin-top: 50px;
  background: #ffffff;
  border: ${({ error, theme }) =>
    error ? `1px solid ${theme.error.base}` : `1px solid ${theme.gray.light}`};
  border-radius: 24px;
`

export const OneTapPayAutopaymentBubble = styled('div')`
  text-align: center;
  box-sizing: border-box;
  width: 50%;
  padding: 10px;
  margin-bottom: 16px;
  margin-top: 24px;
  background: ${({ theme }) =>
    theme.mode.isDark ? 'transparent' : theme.text.white};
  border: ${({ theme }) => `1px solid ${theme.gray.light}`};
  border-radius: 24px;
  margin-left: 28%;
  display: ${({ show }) => show ? 'none' : 'black'};

  @media only screen and (max-width: 767px) {
    width: auto;
    margin: auto;
    margin: 24px 16px;
  }
`

export const LeftSide = styled('td')`
  float: left;
  margin-left: ${({ tabbed }) => (tabbed ? '32px' : '16px')};
  color: ${({ error, theme }) =>
    getEmbeddedViewFlag()
      ? theme.secondary.base
      : error
        ? theme.error.base
        : theme.mode.isDark
          ? theme.mode.text_color
          : theme.black.dark};
`
export const StyledLeftSide = styled(LeftSide)`
  margin-bottom: 24px;
`

export const StyledRecieptIcon = styled(Download)`
  top: 2px;
  position: relative;
  height: 16px;
  width: 16px;
  color: ${({ theme }) => theme.gray.gray5};
`
export const StyledNoteIcon = styled(CircleAdd)`
  top: 2px;
  position: relative;
  height: 16px;
  width: 16px;
  color: ${({ theme }) => theme.gray.gray5};
`

export const StyledDownloadText = styled('span')`
  margin-left: 4px;
  text-align: center;
  font-size: 13px;
`

export const RightSide = styled('td')`
  float: right;
  width: '50%';
  margin-right: ${({ tabbed }) => (tabbed ? '32px' : '16px')};
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.secondary.base};
`

export const BoldHeaderText = styled('span')`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 16px 0px;
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.primary.base};

  @media only screen and (max-width: 767px) {
    font-size: 16px;
  }
`

export const BoldHeaderDetailsText = styled('span')`
  font-weight: 700;
  font-size: 16px;
  margin: 16px 0 24px 0;
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.primary.base};

  @media only screen and (max-width: 767px) {
    font-size: 16px;
  }
`

export const StyledOneTapPaySpan = styled('span')`
  @media only screen and (max-width: 767px) {
    font-size: 15px;
  }
`

export const StyledAddNoteSpan = styled('span')`
  position: relative;
  top: -1px;

  @media only screen and (max-width: 767px) {
    font-size: 15px;
  }
`

export const StyledOneTapPayHr = styled('hr')`
  border: 1px solid #d8dce0;
  margin-left: 16px;
  margin-right: 16px;
`

export const StyledOneTapPayButton = styled('button')`
  background: none;
  border: none;
  color: ${({ theme }) => `${theme.secondary.base}`};
  font-size: 16px;
  padding: 0;
  text-align: right;
  @media only screen and (max-width: 767px) {
    font-size: 14px;
  }
`

export const StyledOneTapPayDiv = styled('div')`
  margin-left: 16px;
  margin-right: 16px;
`

export const StyledAnchorSpan = styled('span')`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.25px;
  color: #007aff;
`

export const StyledMaskedCardText = styled('span')`
  text-align: center;
  margin-left: 16px;
  position: relative;
  top: -10px;
  font-weight: 700;
  font-size: 13px;
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.secondary.base};
`

export const StyledSubmitButton = styled(Button)`
  margin-left: 16px;
  background-color: ${({ theme }) =>
    getEmbeddedViewFlag() && theme.button_primary.background};
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.embedded.button_text};

  @media only screen and (max-width: 450px) {
    width: 65%;
    font-size: 18px;
  }

  @media only screen and (max-width: 350px) {
    font-size: 13px;
    height: 32px;
    width: 150px;
    align-items: center;
    display: inline-flex;
    justify-content: center;
  }
`

export const StyledLogo = styled('span')`
  position: relative;
  top: 5px;
`

export const StyledCheckbox = styled(RoundedCheckBox)`
  margin-bottom:8px;
  cursor: pointer;
`

export const StyledErrorDiv = styled('div')`
  display: flex;
  justify-content: center;
`

export const StyledSlimCard = styled(StyledCard)`
  height: 60px;
  background-color: ${({ disabled, theme }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.foreground_color
      : disabled
        ? theme.gray.light
        : theme.mode.isDark
          ? theme.mode.card_background_color
          : theme.white.base};
  border-color: ${({ theme, disabled }) =>
    getEmbeddedViewFlag()
      ? theme.embedded.input_border_outline
      : disabled
        ? theme.error.base
        : theme.gray.light};
  width: 350px;
  opacity: 1;

  @media only screen and (max-width: 768px) {
    width: calc(100% - 16px);
    margin-bottom: 10px;
  }

  @media only screen and (max-width: 414px) {
    width: calc(100% - 16px);
    margin-bottom: 10px;
  }

  @media only screen and (min-width: 1440px) {
    width: 350px;
  }
`
export const StyledCVVField = styled('div')`
  position: relative;
  left: 20px;
  top: 20px;
  @media only screen and (max-width: 767px) {
    width: 200px;
  }
`

export const StyledDonationAmountWrapper = styled('div')`
  margin-left: -4px;
`

export const StyledCircleCheck = styled(CircleCheck)`
  color: ${({ theme }) => theme.success.base};
  position: relative;
  float: right;
  margin-top: ${({ noMarginTop }) => !noMarginTop && '-16px'};
`

export const StyledToolTipDiv = styled('div')`
  padding: 10px;
  background-color: white;
  opacity: 1;
  border-radius: 10px;
  width: 300px;
`

export const StyledPlaidErrorInfoIcon = styled('span')`
  color: ${({ theme }) => theme.error.base};
  cursor: pointer;
  margin-left: 8px;
  position: relative;
`

export const StyledCircleAdd = styled(CircleAdd)`
  width: 16px;
  height: 16px;
  margin-left: -5px;
  margin-right: 5px;
`

export const StyledAddMethodButton = styled(Button)`
  background-color: #ffffff;
  border: 1px solid #d8dce0;
  margin-left: 16px;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledActionButton = styled(Button)`
  font-size: 14px;
  margin-bottom: ${({ fromNoteModal }) => (fromNoteModal ? '14px' : '0')};

  @media only screen and (max-width: 350px) {
    font-size: 16px;
    height: 30px;
    width: 30px;
    align-items: center;
    display: inline-flex;
    justify-content: center;
  }
`

export const StyledArrow = css`
  pointer-events: all !important;
  cursor: pointer;
  width: 18px;
  float: right;
  height: 18px;
  margin-left: 10px;
  color: ${({ theme }) => theme.gray.gray4};
`

export const StyledPaymentNoteSpan = styled('p')`
  margin: 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.25px;
  word-break: break-word;
  color: ${({ theme }) =>
    theme.mode.isDark ? theme.mode.text_color : theme.gray.gray4};
`

export const StyledCurrencyField = styled(CurrencyField)`
  height: 60px;
  width: 235px;

  @media only screen and (max-width: 600px) {
    width: calc(100% - 16px);
  }
`

export const StyledCustomAmtDiv = styled('div')`
  margin-left: 8px;
  display: ${({ show }) => (show ? 'block' : 'none')};
`

export const StyledDisclaimerText = styled('span')`
  font-size: 13px;
`

export const StyledNote = styled('span')`
  color: ${({ theme }) => theme.black.base};
  font-size: 14px;
  font-weight: 600;
  margin-right: 8px;
`

export const StyledFormRow = styled(Form.Row)`
  height: auto;
  width: auto;
  @media only screen and (max-width: 767px) {
    max-height: 448px;
    overflow-y: auto;
    overflow-x: hidden;
  }
`

export const StyledFormField = styled(Form.Field)`
  margin-left: 16px;
`

export const OneTapPayStyledFormRow = styled(Form.Row)`
  height: auto;
  width: auto;
  @media only screen and (max-width: 767px) {
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
`

export const StyledTextField = styled(TextAreaField)`
  height: 160px;
  margin-top: 18px;
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.secondary.base};
`

export const StyledTable = styled('table')`
  width: 100%;
  margin-top: 16px;
`
export const CardErrorMessage = styled('div')`
  font-size: 11px;
  font-weight: 600;
  color: ${({ theme }) => theme.blue.system_blue};

  @media only screen and (max-width: 768px) {
    font-size: 11px;
    font-weight: 400;
  }
`
export const StyledLock = styled(Lock)`
  position: absolute;
  top: 4px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};
`

export const StyledOneTapLockIcon = styled(Lock)`
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin-right: 12px;
  margin-top: 2px;
`

export const StyledOneTapFingerprintIcon = styled(Fingerprint)`
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  margin-right: 12px;
  margin-top: 2px;
`

export const StyledPlaidMessageDiv = styled('div')`
  margin-left: 8px;
  position: relative;
`

export const StyledB = styled('span')`
  display: inline-block;
  line-height: 2;
  padding: ${({ isfromRPOneTapPay }) => !isfromRPOneTapPay && '0 28px'};
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};
`

export const StyledMsgDiv = styled('div')`
  font-size: 14px;
  line-height: 1.7;
  padding: 0 4px 16px;
`

export const StyledOneTapPayPlaidHeader = styled('h2')`
  flex: 1;
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 500;
  color: ${({ theme }) => theme.text.dark};
  white-space: normal;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    font-size: 14px;
    line-height: 1.4;
  }
`

export const StyledOneTapPayPlaidContent = styled('p')`
  margin: 8px 0 16px 34px;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.text.dark};

  @media screen and (max-width: 767px) {
    margin: 6px 0 12px 34px;
    font-size: 13px;
    line-height: 1.4;
  }
`

export const StyledOneTapPayPlaidWrapper = styled('div')`
  padding: 16px 0;
  
  @media screen and (max-width: 767px) {
    padding: 12px 0;
  }
`

export const titleCss = css`
  font-size: 16px;
  line-height: 2;
  padding: 9px 18px;
  color: ${({ theme }) => `${theme.gray.dark}`};
`

export const classifiedModalDivStyle = css`
  max-width: 300px;
`

export const StyleContinueButton = styled(Button)`
  height: 60px;
  width: 295px;
  border-radius: 30px;
  margin-top: -10px;
  margin-bottom: 8px;
  font-size: 18px !important;
`

export const StyleVerifyButton = styled(StyleContinueButton)`
  margin-top: 10px;
`
export const StyledAddNoteButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  background-color: ${({ theme }) =>
    theme.mode.isDark ? `${theme.mode.card_background_color} !important` : ''};

  @media only screen and (max-width: 500px) {
    width: max-content;
    height: 32px;
    padding: 8px;
  }
`

export const StyledCharityDonationDiv = styled('div')`
  width: 366px;
  height: 100%;
  left: 16px;
  top: 117px;
`

export const StyledOneTapPayCharityIcon = styled('a')`
  box-sizing: border-box;
  background: ${({ theme }) => theme.text.white};
  border: 1px solid ${({ theme }) => theme.text.border};
  border-radius: 8px;
`
export const StyleSlimCharityCard = styled(StyledSlimCard)`
  height: 80px;
  padding: ${({ isSmallScreen }) => !isSmallScreen && '8px'};
  width: 382px;
  border-radius: 16px;
  margin-bottom: 8px;

  @media only screen and (max-width: 768px) {
    min-width: 240px;
    padding: 10px;
  }
`
export const StyleCharityName = styled('div')`
  top: 4px;
  position: relative;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  /* identical to box height, or 112% */
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.gray.gray5};
`
export const StyleSlimCharityIcon = styled('img')`
  float: left;
  height: 64px;
  width: 64px;
  border: ${({ theme }) => `1px solid ${theme.text.white}`};
  border-radius: 8px;

  @media only screen and (max-width: 768px) {
    height: 56px;
    width: 56px;
  }
`
export const StyledSlimCharityWrapper = styled('div')`
  display: table;
  width: ${({ isSmallScreen }) => !isSmallScreen && '100%'};
`
export const StyleCharityWebsite = styled('span')`
  position: relative;
  top: 4px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  /* identical to box height, or 112% */
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.blue.system_blue};
  width: ${({ isSmallScreen }) => (!isSmallScreen ? `200px` : ``)};
`

export const StyledSlimCharityDisplayWrapper = styled('div')`
  margin-left: 16px;
`

export const StyleCharityDisplayName = styled('span')`
  font-size: 16px;
`

export const StyledSelectedCharityDescription = styled('div')`
  height: 18px;
  left: 88px;
  right: 16px;
  top: 20px;
  /* Body Copy (16) */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  /* identical to box height, or 112% */
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.gray.gray5};
  width: ${({ isSmallScreen }) => (isSmallScreen ? '310px' : '650px')};
  overflow-y: auto;
  height: auto;
  margin: 16px 0;
`
export const StyledSlimCharityInfoWrapper = styled('div')`
  position: relative;
  top: 10px;
  margin-left: 80px;
`
export const StyleSlimCharityAmountCard = styled(StyledSlimCard)`
  padding: 0;
  margin-bottom: 16px;
  border: none;
  height: auto;

  @media only screen and (max-width: 414px) {
    margin-bottom: 16px;
  }
`
export const StyledCharitySpan = styled('span')`
  width: 366px;
  height: 18px;
  left: 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 35px;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.gray.gray5};
`

export const StyledWebsiteDiv = styled('div')`
  color: ${({ theme }) => theme.icon.base};
  height: 16px;
  display: flex;
  cursor: pointer;
`
export const StyledErrorInfoIcon = styled('span')`
  color: ${({ theme }) => theme.blue.system_blue};
  cursor: pointer;
  margin-left: 8px;
  position: relative;
`
export const StyledPickerField = styled(PickerField)`
  > button {
    &[aria-selected='true'] {
      background: ${({ theme }) =>
        getEmbeddedViewFlag() && theme.button_primary.background};
      color: ${({ theme }) =>
        getEmbeddedViewFlag() && theme.embedded.button_text};
    }
  }
`
export const StyledConfirmPlaidSection = styled('section')`
  display: ${({ show }) => show}
  flex-direction: column;
`
export const StyledConfirmPlaidContentSection = styled('section')`
  border-bottom: 1px solid ${({ theme }) => theme.gray.light};
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding-bottom: 24px;
  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
  }
`

export const StyledConfirmPlaidH4 = styled('h4')`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 16px 16px 16px 0;
  font-size: 16px;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-left: 0;
  }
`

export const StyledConfirmPlaidH3 = styled('h3')`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 30px 16px 16px 0;
  font-size: 15px;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-left: 0;
  }
`

export const StyledConfirmPlaidWrapper = styled('section')`
  padding: 0;
  @media (max-width: 767px) {
    padding-bottom: 24px;
  }
`

export const StyledConfirmPlaidDiv = styled('div')`
  height: 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: dashed 1px ${({ theme }) => theme.gray.light};
  margin-bottom: 20px;
`

export const StyledConfirmPlaidSpanLeft = styled('span')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.text.dark};
  display: block;
  height: 15px;
  font-size: 15px;
  font-weight: normal;
  padding-right: 6px;
`

export const StyledConfirmPlaidSpanRight = styled('span')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.text.dark};
  display: block;
  height: 15px;
  font-size: 15px;
  font-weight: normal;
  padding-left: 6px;
`

export const StyledConfirmPlaidButtonBar = styled('div')`
  margin-bottom: 24px;
  text-align: ${({ isfromRPOneTapPay }) => isfromRPOneTapPay && 'center'};
`

export const StyledConfirmPlaidPickerField = styled(PickerField)`
  div {
    margin-left: 0;
  }
  label {
    font-size: 13px;
    font-style: italic;
    margin-bottom: 12px;
  }
  > button {
    font-size: 13px;
    background: #f7f7f7;
  }
  @media (max-width: 767px) {
    label {
      font-size: 13px;
      font-style: italic;
      margin-bottom: 8px;
    }
    button {
      height: 51px;
      width: 154px;
      margin-bottom: 24px;
    }
  }
`
export const StyledBackButton = styled('div')`
  margin-right: 10px;
  position: relative;
  top: 2px;
  cursor: pointer;
`
export const StyledMethodModalTitle = styled('span')`
  display: flex;
  justify-content: start;
`
export const StyledModalLabel = styled('div')`
  font-size: 18px;
`

export const StyledNewMethodButtonWrapper = styled('div')`
  display: flex;
  justify-content: center;
`
export const StyledViewDetail = styled('a')`
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.system_blue.color};
`

export const StyledViewDetailDiv = styled('div')`
  display: flex;
  align-items: center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  @media only screen and (max-width: 415px) {
    text-align: center;
  }
`
export const StyledSpanPaymentHeader = styled('span')`
  color: ${({ theme }) => theme.gray.mediumlight};
  font-weight: 400;
  font-size: 13px;
`
export const StyledDivFlex = styled('div')`
  display: flex;
`

export const StyleLeftSide = css`
  div {
    padding: 0;
  }
`
export const StyleDisabledLeftSide = css`
  margin-left: 52px;
  opacity: 0.5;

  @media only screen and (max-width: 768px) {
    margin-left: 36px;
  }
`
export const StyleRadioButton = css`
  height: 30px;
  display: block;
`

export const StyleCVVField = css`
  margin-left: -5px;
`
export const StyleNotAvailbleExpandable = css`
  max-height: 150px;
  overflow: auto;
`
export const rightSideStyle = css`
  margin-top: 10px;
`

export const StyleTooltip = css`
  margin-top: 15px;
`
export const StyleLink = css`
  text-decoration: none;
`

export const StyleCardErrorMessage = css`
  margin-top: 16px;
  margin-left: 5px;
`

export const StyledLink = styled(Link)`
  color: ${({ theme }) =>
    getEmbeddedViewFlag()
      ? theme.secondary.base
      : theme.mode.isDark
        ? theme.mode.text_color
        : theme.black.dark};
`

export const StyledItalicText = styled.em``

export const StyledExpandableTable = styled.table`
  width: 100%;
  margin: 16px;
  margin-right: 16px;
  font-size: 11px;
`

export const StyledErrorText = styled.span`
  color: red;
`

export const StyledPaymentSummarySpan = styled.span`
  display: ${({ paymentSummary }) => (!paymentSummary ? 'block' : 'none')};
`

export const StyledPaymentSummaryDiv = styled.div`
  display: ${({ showSummary }) => (showSummary ? 'block' : 'none')};
`

export const StyledPartialPaymentDiv = styled('div')`
`

export const StyledPaymentMethodField = styled('div')`
  .form-field {
    margin-bottom: 0px !important;
  }
`

export const StyledDublicateApplePayButton = styled('div')`
 > div > div {
  margin: 0px !important;
  pointer-events: ${({ disable }) => (disable ? 'none' : 'initial')};
  opacity: ${({ disable }) => (disable ? '0.5' : 'initial')};

  apple-pay-button {
    --apple-pay-button-width: 361px;
    --apple-pay-button-height: 54px;
    --apple-pay-button-border-radius: 4px;
    --apple-pay-button-padding: 0px 16px;
    --apple-pay-button-box-sizing: border-box;

    // Adjust for tablets and smaller laptops
    @media (max-width: 768px) {
      --apple-pay-button-width: 361px;
    }

    // Adjust for mobile screens
    @media (max-width: 480px) {
      --apple-pay-button-width: 340px;
    }

    @media (max-width: 432px) {
      --apple-pay-button-width: 330px;
    }

    @media (max-width: 430px) {
      --apple-pay-button-width: 325px;
    }

    @media (max-width: 390px) and (max-width: 414px) {
      --apple-pay-button-width: 300px;
    }

    @media (max-width: 412px) {
      --apple-pay-button-width: 290px;
    }

    @media (max-width: 375px) {
      --apple-pay-button-width: 280px;
    }

    // Adjust for very small mobile screens
    @media (max-width: 320px) {
      --apple-pay-button-width: 220px;
    }
  }
 }
`
// Start of Styles ApplePayButtons.jsx

export const ApplePayWallet = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const DisplayApplePayButton = styled('div')`
  margin: 16px 16px 0 16px;
  pointer-events: ${({ disable }) => (disable ? 'none !important' : 'initial !important')};
  opacity: ${({ disable }) => (disable ? '0.5 !important' : 'initial !important')};

  apple-pay-button {
    --apple-pay-button-height: 54px;
    --apple-pay-button-border-radius: 4px;
    --apple-pay-button-padding: 0px 16px;
    --apple-pay-button-box-sizing: border-box;
    --apple-pay-button-width: 670px;

    // Adjust width for apple pay button as per device dimentions 
    // as the standard break points we can not manage the width for apple pay button.

    @media (max-width: 1440px) {
      --apple-pay-button-width: 670px;
    }

    // Adjust for medium-large screens
    @media (max-width: 1024px) {
      --apple-pay-button-width: 620px;
    }

    @media (max-width: 820px) {
      --apple-pay-button-width: 670px;
    }

    // Adjust for tablets and smaller laptops
    @media (max-width: 768px) {
      --apple-pay-button-width: 640px;
    }

    // Adjust for mobile screens
    @media (max-width: 480px) {
      --apple-pay-button-width: 340px;
    }

    @media (max-width: 430px) {
      --apple-pay-button-width: 355px;
    }
    @media (max-width: 432px) {
      --apple-pay-button-width: 345px;
    }

    @media (max-width: 414px) {
      --apple-pay-button-width: 335px;
    }

    @media (max-width: 412px) {
      --apple-pay-button-width: 310px;
    }

    @media (max-width: 390px) {
      --apple-pay-button-width: 290px;
    }

    @media (max-width: 375px) {
      --apple-pay-button-width: 300px;
    }

    // Adjust for very small mobile screens
    @media (max-width: 320px) {
      --apple-pay-button-width: 240px;
    }
  }
`
//End of Styles ApplePayButtons.jsx

export const StyledPaymentHeaderWraper = styled('div')``;

export const StyledFXConversionWrapperContent = styled('div')`
   display: flex;
   align-items: center;
   gap: 10px;
`

export const StyledFXConversionTransfermateType = styled('p')`
  font-size: 14px;
  margin-bottom: 0px;
  font-weight: bolder;
`

export const StyledFXConversionTransfermateAmount = styled('p')`
  font-size: 10px;
  margin-top: 0px;
  font-weight: bolder;
`

export const LeftSideInternational = styled('td')`
  float: left;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: ${({ tabbed }) => (tabbed ? '32px' : '16px')};
  color: ${({ error, theme }) =>
    getEmbeddedViewFlag()
      ? theme.secondary.base
      : error
        ? theme.error.base
        : theme.mode.isDark
          ? theme.mode.text_color
          : theme.black.dark};
`

// Start of PaymentLinkExpired.jsx
export const PaymentLinkExpiredContainer = styled.div`
  color: ${({ theme }) => theme.mode.isDark ? theme.text.dark : theme.black.dark};
  padding: 20px;
  text-align: left;
  width: 100%;

  @media (min-width: 1440px) {
    width: 736px;
    margin: 0 auto;
  }
`;

export const PaymentLinkExpiredErrorMessage = styled.div`
  background-color: ${({ theme }) => theme.mode.isDark ? '#561410' : theme.error.light};
  color: ${({ theme }) => theme.mode.isDark ? theme.text.dark : theme.black.dark};
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.25px;
  text-align: left;
`;

export const PaymentLinkExpiredIcon = styled.span`
  font-size: 20px;
  margin-right: 10px;

  svg {
    vertical-align: middle;
  }
`;

export const PaymentLinkExpiredTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0.5px;
  margin-bottom: 0;
`;

export const PaymentLinkExpiredDescription = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin: 24px 0 0 0;
`;

// End of PaymentLinkExpired.jsx

// Start of OTPField.jsx

export const StyledOTPContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-top: 1px solid ${({ theme }) => theme.clubs.buttonDivBorderColor};
  margin-top: 16px;
  margin-right: 16px;
`;

export const StyledForm = styled(Form)`
  width: 70%;
`;

export const StyledOTPField = styled("div")`
  width: 124px;
  margin-bottom: 0;

  label {
    margin-left: 15px;
  }
`;

export const StyledVerifyButtonContainer = styled("div")`
  button {
    margin-left: 0;
    margin-top: 0;
  }
`;

export const StyledSentCodeContainer = styled("div")`
  margin-bottom: 12px;
`;

export const StyledOtpMsgDiv = styled("div")`
  align-self: stretch;
  color: ${({ theme }) => theme.quickLinks.textcolor};
  font-feature-settings: "liga" off, "clig" off;
  margin-top: 12px;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.25px;
`;

//End of OTPField.jsx

// Start of OTPTimer.jsx


export const StyledSentCodeLink = styled('div')`
  width: 115px;
  color: ${({ theme }) => theme.clubs.joinClub};
  text-align: left;
  font-feature-settings: "liga" off, "clig" off;
  cursor: pointer;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.25px;
  margin-left: 12px;
`;

// Styled message for "Sent Code"
export const StyledSentCodeMessage = styled('span')`color: ${({ theme }) => theme.mode.isDark ? theme.mode.text_color : theme.black.base};
`;

// End of OTPTimer.jsx

export const HideArrow = css`
 display: none;
`
export const StyledPaymentModeError = styled('td')`
  font-size: 16px;
  color: red;
  
`
// Start of DefaultPaymentMethodCheckboxField.jsx

export const StyledDefaultPaymentMethodCheckboxFieldRow = styled(Form.Row)`
  margin-top: 8px;
`
export const IconWrapper = styled('span')`
  display: flex;
  svg {
    height: 18px;
    width: 18px;
    cursor: pointer;
    pointer-events: auto !important;
    @media only screen and (min-width: 1024px) {
      text-transform: capitalize;
    }
    @media only screen and (max-width: 480px) {
      height: 20px;
      width: 20px;
    }
    path {
      fill: ${({ theme }) => theme.gray.mediumlight};
    }
  }
`

export const ModalContainer = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: normal;
`
export const StyledRoundedCheckbox = styled(RoundedCheckBox)`
  label {
    color: ${({ theme }) => getEmbeddedViewFlag() ? theme.secondary.base : theme.gray.mediumlight };
    font-size: 13px;
    font-weight: 400;
  }
`
// End of DefaultPaymentMethodCheckboxField.js


// Start of Wallet.jsx
export const StyledAddCardWrapper = styled('div')`
  width: 100%;
  ${({ disabled, theme }) => disabled && `
    pointer-events: none;
    opacity: 0.7;
    button {
      border-color: ${theme.gray.gray_300} !important;
      color: ${theme.gray.gray_300} !important;
      cursor: not-allowed !important;
    }
  `}
  
  button {
    width: 100%;
    padding: 12px;
    font-size: 14px;
    min-height: 44px;
  }

  @media screen and (min-width: 768px) {
    button {
      width: auto;
      padding: 16px;
      font-size: 16px;
    }
  }
`

export const StyledMessageBox = styled('div')`
  margin: 12px 0;
  padding: 0 12px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;

  @media screen and (min-width: 768px) {
    margin: 16px 0;
    padding: 0;
  }
`

export const StyledMessageContent = styled('div')`
  background-color: rgb(228, 241, 252);
  color: ${({ theme }) => theme.text.black};
  padding: 12px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  svg {
    flex-shrink: 0;
    fill: currentColor;
    color: rgb(0, 118, 230);
  }

  @media screen and (min-width: 768px) {
    padding: 16px;
    font-size: 14px;
    line-height: 1.5;
  }
`
// End of Wallet.jsx

export const StyledOneTapPayPlaidSection = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  width: 100%;
  flex-wrap: nowrap;
  gap: 12px;
`;
